<body class="size-audit">
  <div class="size-audit-container">
    <h3 class="page-title">{{ CONST.SIZE_AUDIT }}</h3>
    <ion-row>
      <ion-col size="12">
        @if (isFormSubmitted(); as submitted) {
          @if (submitted && form.errors?.dimensionError) {
            <span class="error-message"
              >{{ CONST.INVALID_DIMENSION }},&nbsp;
              {{
                CONST.INVALID_RANGE.replace(
                  "%min",
                  form.errors?.dimensionError.min
                ).replace("%max", form.errors?.dimensionError.max)
              }}
            </span>
          }
        }
      </ion-col>
      <ion-col size="10">
        <app-add-new-scan
          #addNewScan
          [form]="form"
          [isFormSubmitted]="!!isFormSubmitted()"
          [hasFileUpload]="false"
          [hasButton]="false"
          [triggerAPIOnSubmit]="true"
          [fileType]="PARSE_TYPE.SIZE_AUDIT"
          (emitSubmit)="submit($event, false)"
          (emitFileUpload)="submit($event, true)"
        >
          <ion-row [formGroup]="form">
            <ion-col size="auto">
              <app-form-input-field
                class="input-field"
                [label]="CONST.LENGTH"
                [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                [suffix]="unitConfig['length']"
                formControlName="lengthInput"
                [maxLength]="5"
                [required]="true"
              ></app-form-input-field>
            </ion-col>
            <ion-col size="auto">
              <app-form-input-field
                class="input-field"
                [label]="CONST.WIDTH"
                [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                [suffix]="unitConfig['width']"
                formControlName="widthInput"
                [maxLength]="5"
                [required]="true"
              ></app-form-input-field>
            </ion-col>
            <ion-col size="auto">
              <app-form-input-field
                class="input-field"
                [label]="CONST.HEIGHT"
                [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                [suffix]="unitConfig['height']"
                formControlName="heightInput"
                [maxLength]="5"
                [required]="true"
              ></app-form-input-field>
            </ion-col>
            <ion-col size="auto" class="checkbox">
              <app-form-checkbox
                [label]="CONST.PALLET"
                formControlName="palletCheckBox"
              ></app-form-checkbox>
            </ion-col>
            <app-file-upload-button
              [disabled]="
                !form.get('sortDate')?.value ||
                !form.get('sortCode')?.value ||
                !form.get('lengthInput')?.value ||
                !form.get('widthInput')?.value ||
                !form.get('heightInput')?.value
              "
              (uploadClick)="addNewScanComponent.fileUpload()"
            ></app-file-upload-button>
            <ion-col size="auto" class="submit-button">
              <ion-button
                [disabled]="form.invalid"
                class="submit-btn"
                (click)="addNewScanComponent.clickSubmit()"
              >
                {{ CONST.SUBMIT }}
              </ion-button>
            </ion-col>
          </ion-row>
        </app-add-new-scan>
      </ion-col>
      <!-- Icons -->
      @if (dataSource.data.length > 0 && !isFileUpload) {
        <ion-col size="2" class="top-icons ion-no-padding action-btn-column">
          <app-filter-icon
            [isDisabled]="!isFilterEnabled"
            (clearFilterEvent)="clearAllFilters()"
          >
          </app-filter-icon>
        </ion-col>
      }
    </ion-row>

    <!-- Table -->
    @if (dataSource.data.length > 0 && !isFileUpload) {
      <div class="size-audit-table-container">
        <table
          mat-table
          [dataSource]="dataSource"
          id="excel-table"
          class="size-audit-table"
        >
          <!-- Tracking Numbers -->
          <ng-container matColumnDef="trackingNumber">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="trackingNumber-headers"
              class="tracking-number-column-header"
            >
              <app-table-search-component
                [columnName]="COLUMNTEXT.TRACKING_NUMBER"
                [control]="trackingNumber.formControl"
                [maxLength]="18"
                [textInputWidth]="339"
                [searchIconOffset]="132"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              headers="tracking-number-header"
              class="selectable cursor-pointer"
              mat-cell
              *matCellDef="let auditRow; let i = index"
            >
              <app-table-tracking-number-cell
                [trackingNumber]="auditRow.trackingNumber"
              ></app-table-tracking-number-cell>
            </td>
          </ng-container>

          <!-- Sort Date -->
          <ng-container matColumnDef="sortDate">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortDate-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.SORT_DATE }}</ion-row>
              <div class="sort-date-picker-container date-picker-container">
                <app-form-date-picker
                  [icon]="SRC.CALENDAR"
                  [placeholder]="CONST.SELECT_DATE"
                  [formControl]="sortDate.formControl"
                  [minDate]="tableMinSortDate"
                  [maxDate]="tableMaxSortDate"
                  [enabledDates]="enabledDates"
                  (valueChange)="search()"
                ></app-form-date-picker>
              </div>
            </th>

            <td
              headers="sort-date-header"
              mat-cell
              *matCellDef="let auditRow; let i = index"
            >
              {{ auditRow.sortDate }}
            </td>
          </ng-container>

          <!-- Sort Code -->
          <ng-container matColumnDef="sortCode">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortCode-headers"
              class="sortCode-header-container"
            >
              <app-table-header-dropdown
                [columnText]="COLUMNTEXT.SORT_CODE"
                [itemId]="sortCode.itemId"
                [searchResults]="sortCodeOption"
                [resetData]="resetSelectDropdowns"
                [showDropdown]="dropdownOpen[0]"
                (dropdownChange)="
                  dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
                "
                (checkboxesUpdated)="
                  onStatusChangeForDropdowns($event, sortCode)
                "
                [popoverStyle]="{ maxWidth: 100, offsetX: -65 }"
              >
              </app-table-header-dropdown>
            </th>

            <td
              mat-cell
              *matCellDef="let auditRow; let i = index"
              headers="sort-code-header"
            >
              {{ auditRow.sortCode }}
            </td>
          </ng-container>

          <!-- Length -->
          <ng-container matColumnDef="length">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="length-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.LENGTH.replace("%unit", unitConfig["length"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let auditRow; let i = index"
              headers="length-column-header"
            >
              {{ auditRow.length }}
            </td>
          </ng-container>

          <!-- Width -->
          <ng-container matColumnDef="width">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="width-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.WIDTH.replace("%unit", unitConfig["width"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let auditRow; let i = index"
              headers="width-column-header"
            >
              {{ auditRow.width }}
            </td>
          </ng-container>

          <!-- Height -->
          <ng-container matColumnDef="height">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="height-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.HEIGHT.replace("%unit", unitConfig["height"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let auditRow; let i = index"
              headers="height-column-header"
            >
              {{ auditRow.height }}
            </td>
          </ng-container>

          <!-- UDW Type -->
          <ng-container matColumnDef="udwType">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="udw-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.UOW_TYPE }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let auditRow; let i = index"
              headers="udw-type-header"
            >
              {{ auditRow.udwType }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-border no-results"
              [attr.colspan]="displayedColumns.length"
            >
              <app-no-results-found></app-no-results-found>
            </td>
          </tr>
        </table>
      </div>
    }

    @if (
      isFileUpload &&
      (commonUtils.fileUploadResponse().accepted > 0 ||
        commonUtils.fileUploadResponse().rejected.length > 0 ||
        commonUtils.fileUploadResponse().itemsNonProcessed.length > 0)
    ) {
      <app-file-upload-results
        [response]="commonUtils.fileUploadResponse()"
      ></app-file-upload-results>
    }
  </div>
</body>
